import MainLayout from "layouts/Main";
import { settingsTabs } from "views/Dashboard/Settings/tabs";

import OperatorsTable from "./OperatorsTable";

const Users = () => {
  return (
    <MainLayout tabs={settingsTabs}>
      <OperatorsTable />
    </MainLayout>
  );
};

export default Users;
